const favourite = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%20.74l3.603%207.3%208.057%201.172-5.83%205.682%201.376%208.024L12%2019.13l-7.206%203.788%201.376-8.024L.34%209.212%208.397%208.04%2012%20.74zm0%204.52L9.725%209.869l-5.087.74%203.681%203.587-.869%205.066L12%2016.87l4.55%202.392-.87-5.066%203.682-3.588-5.087-.74L12%205.26z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  favourite as default
};
//# sourceMappingURL=favourite.svg.es.js.map
